import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  API_FAILED,
  VERIFY_USER,
  SET_USER_ID,
  SET_SUBSCRIPTIONS,
  SET_USER_STATUS,
  UPDATE_ACCOUNT,
  UPDATE_ENTITIES,
} from "./constants";

export const updateAccount = (payload) => ({
  type: UPDATE_ACCOUNT,
  payload: payload,
});

export const updateEntities = (entities) => ({
  type: UPDATE_ENTITIES,
  payload: entities,
});


export const setSubscriptions = (payload) => ({
  type: SET_SUBSCRIPTIONS,
  payload: payload,
});

export const setUserStatus = (payload) => ({
  type: SET_USER_STATUS,
  payload: payload,
});

export const loginUser = (username, password, history) => ({
  type: LOGIN_USER,
  payload: { username, password, history },
});

export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user,
});

export const setUserID = (user, history) => ({
  type: SET_USER_ID,
  payload: { user, history },
});

export const verifyUser = (user, history) => ({
  type: VERIFY_USER,
  payload: { user, history },
});

export const registerUser = (user, history) => ({
  type: REGISTER_USER,
  payload: { user, history },
});

export const registerUserSuccess = (user) => ({
  type: REGISTER_USER_SUCCESS,
  payload: user,
});

export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload: { history },
});

export const forgetPassword = (email) => ({
  type: FORGET_PASSWORD,
  payload: { email },
});

export const forgetPasswordSuccess = (passwordResetStatus) => ({
  type: FORGET_PASSWORD_SUCCESS,
  payload: passwordResetStatus,
});

export const apiError = (error) => ({
  type: API_FAILED,
  payload: error,
});
